import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { initialSecurityState } from "./security.types";
import { SecurityActions } from ".";
import {
  CLEAR_SECURITY_GROUP,
  FETCH_ROLES_LIST_FAILED,
  FETCH_ROLES_LIST_PROGRESS,
  FETCH_ROLES_LIST_SUCCESS,
  FETCH_SECURITY_GROUP_FAILED,
  FETCH_SECURITY_GROUP_PROGRESS,
  FETCH_SECURITY_GROUP_SUCCESS,
} from "./securityActions";

export const securityReducer = (
  state: IStoreState["security"] = initialSecurityState,
  action: SecurityActions
) => {
  switch (action.type) {
    case FETCH_SECURITY_GROUP_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.groups.loading = LoadState.InProgress;
        draftState.groups.group = initialSecurityState['groups']['group'];
        draftState.groups.error = null;
      });
      return newState;
    }
    case FETCH_SECURITY_GROUP_SUCCESS: {
      const { data,role, roleId,status } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.groups.loading = LoadState.Loaded;
        draftState.groups.group = data;
       draftState.groups.roleName = role;
       draftState.groups.roleId = roleId;
       draftState.groups.status = status;
      });
      return newState;
    }

    case FETCH_SECURITY_GROUP_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.groups.loading = LoadState.Failed;
        draftState.groups.error = errorMessage ? errorMessage : null;
      });
      return newState;
    }

    case FETCH_ROLES_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.roles.loading = LoadState.InProgress;
        draftState.roles.list = [];
      });
      return newState;
    }
    case FETCH_ROLES_LIST_SUCCESS: {
      const { list,totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.roles.loading = LoadState.Loaded;
        draftState.roles.list = list;
        draftState.roles.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_ROLES_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.roles.loading = LoadState.Failed;
        draftState.roles.list = [];
        draftState.roles.totalRecords = 0;
      });
      return newState;
    }

    case CLEAR_SECURITY_GROUP: {
      const newState = produce(state, (draftState) => {
        draftState.groups = initialSecurityState["groups"];
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
